import { Col, DatePicker, Form, Input, Row } from "antd";
import { DateFormats } from "../../../../types/typesConstants";
import { EstadoPeriodosContableSelect } from "../EstadoPeriodosContableSelect";
import { FormItemHiddenUi } from "../../../ui";

export const PeriodoContableForm = () => {
  return (
    <>
      <FormItemHiddenUi name="id" />
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col xs={24} sm={24} md={16} lg={16} xl={16}>
          <Form.Item
            name="nombre"
            label="Nombre"
            rules={[{ required: true, message: "El nombre es requerido" }]}
          >
            <Input placeholder="Ingresa nombre del periodo contable" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <Form.Item
            name="estado"
            label="Estado"
            rules={[{ required: true, message: "El estado es requerido" }]}
          >
            <EstadoPeriodosContableSelect placeholder="[-Seleccione-]" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col xs={24} sm={24} md={12} lg={10} xl={6}>
          <Form.Item
            name="fechainicio"
            label="Fecha de inicio"
            rules={[
              {
                required: true,
                message: "La fecha de inicio es requerido",
              },
            ]}
          >
            <DatePicker format={DateFormats.frontend} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={10} xl={6}>
          <Form.Item name="fechafin" label="Fecha de fin">
            <DatePicker format={DateFormats.frontend} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
